<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-if="ifFirstShow" label="表单设计" name="first">
        <FormDesingView :visitType="visitType"></FormDesingView>
      </el-tab-pane>
      <el-tab-pane v-if="ifSecondShow" label="审批设计" name="second">
        <FlowDesingView :visitType="visitType"></FlowDesingView>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import FlowDesingView from './FlowDesingView.vue';
import FormDesingView from './FormDesingView.vue';

export default {
  props: ['visitType'],

  components: {
    FlowDesingView, FormDesingView,
  },

  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },

  mounted() {
    this.activeName = this.defaultActiveName
  },

  computed: {
    defaultActiveName: function () {
      if (this.ifFirstShow) {
        return "first"
      } else {
        return "second"
      }
    },

    ifFirstShow: function () {
      const group = ["VISITOR_FORM_SELECT", "VISITOR_FORM_MODIFY"]
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
        case "VIEW":
          return true
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return group.some((item) => {
            return this.$store.state.myPermissions.includes(item)
          })

        default:
          return false
      }
    },

    ifSecondShow() {
      const group = ["VISITOR_FLOW_SELECT", "VISITOR_FLOW_MODIFY"]
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
        case "VIEW":
          return true
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return group.some((item) => {
            return this.$store.state.myPermissions.includes(item)
          })
        default:
          return false
      }
    },

  },
}
</script>

<style></style>
